import axios from '../../../requesters/axios';
// import cookie from 'react-cookie';

// import { API_URL } from '../../../../erp/actions';
import {
  SWITCH_TECHNICAL_CARD_TAB,
  TECHNICAL_CARD_UPLOAD_SUCCESS,
  CAR_DATA_FORM_VALUES_SUCCESS,
  STORE_CAR_DATA_FORM_VALUES_SUCCESS,
  STORE_CAR_DATA_FORM_VALUES,
  CLEAR_CAR_DATA_STORE,
  STOP_LOADING_CAR_DATA,
} from './types';

export function switchTechnicalCardTab(newTab) {
  return (dispatch) => {
    dispatch({
      type: SWITCH_TECHNICAL_CARD_TAB,
      payload: {
        newTab,
      },
    });
  };
}

export function uploadImage(files) {
  return (dispatch) => {
    // TODO: MAKE API CALL
    setTimeout(() => {
      dispatch({
        type: TECHNICAL_CARD_UPLOAD_SUCCESS,
        payload: {
          file: files,
        },
      });
    }, 1500);
  };
}

export function getCarDataFormValues() {
  return (dispatch) => {
    axios.get(`/cars/manufacturers/all`)
      .then((response) => {
        dispatch({
          type: CAR_DATA_FORM_VALUES_SUCCESS,
          payload: {
            data: response.data,
            engines: ['Gasolina', 'Diesel', 'Híbrido'],
            loadingCarDataForm: false,
          }
        });
      });
  };
}

export function storeCarDataFormValues(values) {
  return (dispatch) => {
    dispatch({
      type: STORE_CAR_DATA_FORM_VALUES_SUCCESS,
      payload: {
        values,
      },
    });
  };
}

export function storeCarDataFormValuesPartially(values) {
  return (dispatch) => {
    dispatch({
      type: STORE_CAR_DATA_FORM_VALUES,
      payload: {
        values,
      },
    });
  };
}

export function clearCarDataStore(props) {
  return (dispatch) => {
    dispatch({
      type: CLEAR_CAR_DATA_STORE,
      payload: {
        props,
      }
    });
  }
}

export function stopLoading() {
  return (dispatch) => {
    dispatch({
      type: STOP_LOADING_CAR_DATA,
    });
  };
}




// WEBPACK FOOTER //
// ./src/workflow/checkout/carData/actions.js